import i18n from 'i18next';

export const isLang = (lang) => i18n.language === lang